import type { ReactElement } from 'react';
import { PageHeader } from '@/shared/ui';
import { SiteSettingsPanel } from '@/widgets/site-settings-panel';

/** 카카오톡 채널 설정(/settings/site, 사이드바 '설정 > 카카오톡 채널') — 설정 위젯을 조합만 한다. */
export const SiteSettingsPage = (): ReactElement => (
  <>
    <PageHeader
      title="카카오톡 채널"
      description="고객용 웹 오른쪽 아래 카카오톡 상담 버튼이 연결할 채널을 정합니다. 바꾼 주소는 재배포 없이 바로 적용됩니다."
    />
    <SiteSettingsPanel />
  </>
);
